export const ADD_NOTE_TO_CHAIN = "ADD_NOTE_TO_CHAIN"
export const ADD_NOTE_TO_CHAIN_ERR = "ADD_NOTE_TO_CHAIN_ERR"

export const GET_NOTES_BY_CHAIN = "GET_NOTES_BY_CHAIN"
export const GET_NOTES_BY_CHAIN_ERR = "GET_NOTES_BY_CHAIN_ERR"

export const CLEAR_NOTES_BY_CHAIN = "CLEAR_NOTES_BY_CHAIN"